import React from 'react';

import { ActionIcon, Avatar, Group, Paper, px, Stack, Text, useMantineTheme } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { StripeTerminalReader } from 'types';
import { STRIPE_TERMINAL_READER_IMAGES } from 'utils/external-resources';

const StripeTerminalReaderListItem = ({
  stripeTerminalReader,
  onDeleteClick,
}: {
  stripeTerminalReader: StripeTerminalReader;
  onDeleteClick?: () => void;
}): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Paper withBorder bg='gray.1' p='sm'>
      <Group position='apart' noWrap>
        <Avatar
          radius='md'
          size='lg'
          src={STRIPE_TERMINAL_READER_IMAGES[stripeTerminalReader.deviceType] ?? null}
        />
        <Stack spacing='xs'>
          <Text color='dark'>
            {stripeTerminalReader.deviceType} - {stripeTerminalReader.label}
          </Text>
          <Text color='dark'>ID: {stripeTerminalReader.stripeTerminalReaderId}</Text>
        </Stack>

        {onDeleteClick && (
          <ActionIcon color='gray' variant='subtle' size='lg' onClick={onDeleteClick} title='Delete reader'>
            <IconTrash size={`${px(theme.fontSizes.xs) * 2}px`} />
          </ActionIcon>
        )}
      </Group>
    </Paper>
  );
};

export default StripeTerminalReaderListItem;
